import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"

import MuiCheckbox from "components/MuiCheckbox"
import MuiTextField from "components/MuiTextField"
import { ProjectFormPageProps } from "components/ProjectForm"
import ProjectFormFooter from "components/ProjectForm/components/ProjectFormFooter"
import usePocDetails, { EPocDetailsFields } from "./usePocDetails"

const PocDetails = (props: ProjectFormPageProps) => {
    const { states, functions } = usePocDetails(props)

    return (
        <>
            <Box
                display={"flex"}
                flexDirection={"column"}
                gap={4}
                className="custom-scrollbar"
                maxHeight={"65vh"}
                padding={"var(--mui-modal-padding)"}
                sx={{
                    overflowY: "auto",
                }}>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Box display="flex" justifyContent={"space-between"}>
                            <Typography
                                fontSize={"14px"}
                                variant="label"
                                textTransform={"uppercase"}
                                color={"statiqOrange.main"}>
                                ON-GROUND POC DETAILS
                            </Typography>

                            <Box display="flex" alignItems="center">
                                <MuiCheckbox
                                    size="small"
                                    checked={states.sameAsAccountContact}
                                    onChange={e => functions.handleSameAsAccountContactChange(e.target.checked)}
                                    sx={{
                                        marginRight: 0,
                                        marginBottom: "2px",
                                    }}
                                />
                                <Typography fontSize={"13px"} variant="label" fontWeight={400}>
                                    Same as Account Contact
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Box display="flex" flexDirection="column" gap={1}>
                            <Typography variant="label">Name*</Typography>
                            <MuiTextField
                                placeholder="Enter Name"
                                size="large"
                                name={EPocDetailsFields.ON_GROUND_POC_NAME}
                                value={states.formik.values[EPocDetailsFields.ON_GROUND_POC_NAME]}
                                onChange={states.formik.handleChange}
                                error={functions.hasError(EPocDetailsFields.ON_GROUND_POC_NAME)}
                                disabled={states.sameAsAccountContact}
                            />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Box display="flex" flexDirection="column" gap={1}>
                            <Typography variant="label">Contact*</Typography>
                            <MuiTextField
                                placeholder="Enter Contact"
                                size="large"
                                name={EPocDetailsFields.ON_GROUND_POC_PHONE}
                                value={states.formik.values[EPocDetailsFields.ON_GROUND_POC_PHONE]}
                                onChange={states.formik.handleChange}
                                error={functions.hasError(EPocDetailsFields.ON_GROUND_POC_PHONE)}
                                disabled={states.sameAsAccountContact}
                                slotProps={{
                                    htmlInput: {
                                        maxLength: 10,
                                    },
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Box display="flex" flexDirection="column" gap={1}>
                            <Typography variant="label">Email ID*</Typography>
                            <MuiTextField
                                placeholder="Enter Email ID"
                                size="large"
                                name={EPocDetailsFields.ON_GROUND_POC_EMAIL}
                                value={states.formik.values[EPocDetailsFields.ON_GROUND_POC_EMAIL]}
                                onChange={states.formik.handleChange}
                                error={functions.hasError(EPocDetailsFields.ON_GROUND_POC_EMAIL)}
                                disabled={states.sameAsAccountContact}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <ProjectFormFooter
                submitButtonText="Submit"
                handleCloseForm={props.handleCloseForm}
                handleSubmit={() => states.formik.handleSubmit()}
                isLoading={states.isUpdatingPageData}
            />
        </>
    )
}

export default PocDetails
